import script from "./SelectFile.vue?vue&type=script&setup=true&lang=ts"
export * from "./SelectFile.vue?vue&type=script&setup=true&lang=ts"

import "./SelectFile.vue?vue&type=style&index=0&id=10dd22df&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10dd22df"]])

export default __exports__